import Joi from "joi-browser";
import { ASSISTANT } from "../Assistant";

const fields = {
  // whatsappTransferTrigger: {
  //   template: {
  //     name: "whatsappTransferTrigger",
  //     type: "textArea",
  //     style: { height: "100px", fontSize: "13px" },
  //     label: "Transfer Trigger",
  //   },
  //   schema: Joi.string().allow(null, ""),
  // },
  transferTrigger: {
    template: {
      name: "transferTrigger",
      type: "textArea",
      style: { height: "100px", fontSize: "13px" },
      label: "Transfer Trigger",
    },
    schema: Joi.string().allow(null, ""),
  },
  transferMessage: {
    template: {
      name: "transferMessage",
      type: "textArea",
      style: { rows: 3, fontSize: "13px" },
      label: "Transfer Message",
    },
    schema: Joi.string().allow(null, ""),
  },
  officeHours: {
    template: {
      name: "officeHours",
      type: "toggle",
      label: "Transfer only during office hours",
    },
    schema: Joi.boolean().required(),
  },
  transferOnMediaMessage: {
    template: {
      name: "transferOnMediaMessage",
      type: "toggle",
      label: "Transfer on Media Message",
    },
    schema: Joi.boolean().required(),
  },
  postTransferTranscriptionEnabled: {
    template: {
      name: "postTransferTranscriptionEnabled",
      type: "toggle",
      label: "Human Agent Call Transcription",
      description: "Enable to transcribe customer-human agent conversation",
    },
    schema: Joi.boolean().required(),
  },
  postTransferTranscriptionDelay: {
    template: {
      name: "postTransferTranscriptionDelay",
      type: "number",
      label: "Transcription Start Delay After Transfer",
      description:
        "Seconds to wait before transcribing the customer–agent call.",
    },
    schema: Joi.number().min(0).required().label("Delay (Seconds)"),
  },
  maxPostTransferTranscriptionDuration: {
    template: {
      name: "maxPostTransferTranscriptionDuration",
      type: "number",
      label: "Max Transcription Duration After Transfer (seconds)",
      description:
        "The duration to transcribe the customer–agent call after transfer.",
    },
    schema: Joi.number().min(0).required().label("Max Duration (Seconds)"),
  },
  transferType: {
    template: {
      name: "transferType",
      type: "select",
      label: "Transfer Type",
      options: [
        {
          id: 1,
          value: "cold",
          label: "Cold Transfer",
        },
        { id: 2, value: "warm", label: "Warm Transfer" },
      ],
    },
    schema: Joi.string().required().label("Transfer Type"),
  },
  holdMusicUrl: {
    template: {
      name: "holdMusicUrl",
      type: "text",
      label: "Hold Music URL (Warm Transfer)",
    },
    schema: Joi.string().allow(null, "").label("Hold Music URL"),
  },
  warmTransferFallbackMessage: {
    template: {
      name: "warmTransferFallbackMessage",
      label: "Warm Transfer Fallback Message",
      type: "textArea",
      style: { rows: 3, fontSize: "13px" },
    },
    schema: Joi.when("transferType", {
      is: "warm",
      then: Joi.string().required().label("Warm Transfer Fallback Message"),
      otherwise: Joi.string().allow(null, ""),
    }),
  },
  warmTransferRingTimeout: {
    template: {
      name: "warmTransferRingTimeout",
      label: "Warm Transfer Ring Timeout",
      type: "number",
    },
    schema: Joi.when("transferType", {
      is: "warm",
      then: Joi.number().min(5).label("Warm Transfer Ring Timeout"),
      otherwise: Joi.number().min(0)
    })
  },
  agentBriefingLanguage: {
    template: {
      name: "agentBriefingLanguage",
      label: "Agent Briefing Language",
      type: "text"
    },
    schema: Joi.string().allow(null, "").label("Agent Briefing Language")
  }
};

const voiceAssistantFields = {
  transferMessage: fields.transferMessage,
  officeHours: fields.officeHours,
  transferType: fields.transferType,
  holdMusicUrl: fields.holdMusicUrl,
  warmTransferFallbackMessage: fields.warmTransferFallbackMessage,
  warmTransferRingTimeout: fields.warmTransferRingTimeout,
  agentBriefingLanguage: fields.agentBriefingLanguage,
  postTransferTranscriptionEnabled: fields.postTransferTranscriptionEnabled,
  postTransferTranscriptionDelay: fields.postTransferTranscriptionDelay,
  maxPostTransferTranscriptionDuration:
    fields.maxPostTransferTranscriptionDuration,
};

const smsAssistantFields = {
  transferTrigger: fields.transferTrigger,
  transferMessage: fields.transferMessage,
};

const whatsappAssistantFields = {
  transferTrigger: fields.transferTrigger,
  transferMessage: fields.transferMessage,
  // officeHours: fields.officeHours,
  transferOnMediaMessage: fields.transferOnMediaMessage,
};

const messengerAssistantFields = {
  transferTrigger: fields.transferTrigger,
  transferMessage: fields.transferMessage,
  // officeHours: fields.officeHours,
  transferOnMediaMessage: fields.transferOnMediaMessage,
};

const instagramAssistantFields = {
  transferTrigger: fields.transferTrigger,
  transferMessage: fields.transferMessage,
  // officeHours: fields.officeHours,
  transferOnMediaMessage: fields.transferOnMediaMessage,
};

const getTemplateAndSchema = (fields) => {
  return Object.keys(fields).reduce(
    (acc, field) => {
      const { template, schema } = acc;
      const fieldObj = fields[field];
      return {
        template: [...template, fieldObj.template],
        schema: {
          ...schema,
          [field]: fieldObj.schema,
        },
      };
    },
    { template: [], schema: {} },
  );
};

function getInputFields(settings, fields) {
  return Object.keys(fields).reduce((acc, field) => {
    return {
      ...acc,
      [field]: settings[field],
    };
  }, {});
}

function getTransferSettingsByAssistantType(assistantType, settings) {
  switch (assistantType) {
    case ASSISTANT.SMS:
      return {
        ...getTemplateAndSchema(smsAssistantFields),
        inputField: getInputFields(settings, smsAssistantFields),
      };
    case ASSISTANT.VOICE:
      return {
        ...getTemplateAndSchema(voiceAssistantFields),
        inputField: getInputFields(settings, voiceAssistantFields),
      };
    case ASSISTANT.WHATSAPP:
      return {
        ...getTemplateAndSchema(whatsappAssistantFields),
        inputField: getInputFields(settings, whatsappAssistantFields),
      };
    case ASSISTANT.EMAIL:
      return {
        ...getTemplateAndSchema(smsAssistantFields),
        inputField: getInputFields(settings, smsAssistantFields),
      };
    case ASSISTANT.CHAT:
      return {
        ...getTemplateAndSchema(smsAssistantFields),
        inputField: getInputFields(settings, smsAssistantFields),
      };
    case ASSISTANT.INSTAGRAM:
      return {
        ...getTemplateAndSchema(instagramAssistantFields),
        inputField: getInputFields(settings, instagramAssistantFields),
      };
    case ASSISTANT.MESSENGER:
      return {
        ...getTemplateAndSchema(messengerAssistantFields),
        inputField: getInputFields(settings, messengerAssistantFields),
      };
    default:
      return {
        ...getTemplateAndSchema(smsAssistantFields),
        inputField: getInputFields(settings, smsAssistantFields),
      };
  }
}

export { getTransferSettingsByAssistantType };
